import { setPageAction } from './setPageAction';

export type CspViolation = {
  directive: string;
  blockedURI: string;
  sourceFile: string;
  lineNumber: number;
  disposition: string;
  documentURI: string;
};

// gloss
export const trackCspViolations = (): void => {
  const queue = (globalThis as { __cspViolations?: CspViolation[] }).__cspViolations;
  if (!queue) return;

  const reported = new Set<string>();
  const report = (violation: CspViolation) => {
    const key = `${violation.directive} ${violation.blockedURI} ${violation.sourceFile}:${violation.lineNumber}`;
    if (reported.has(key)) return;
    reported.add(key);
    setPageAction('CspViolation', violation);
  };

  queue.splice(0).forEach(report);
  queue.push = (...violations: CspViolation[]) => {
    violations.forEach(report);
    return 0;
  };
};
